import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {environment} from "@env/environment";
import {PlatformModule} from "./platform-module.model";
import {MasterDetailCrudComponent} from "@ui-webkit/components/crud-master-detail/master-detail-crud.component";

@Component({
  selector: 'app-feature-config-modules',
  standalone: true,
  imports: [CommonModule, MasterDetailCrudComponent],
  templateUrl: './feature-config-modules.component.html'
})
export class FeatureConfigModulesComponent {
  protected modelType = PlatformModule;
  protected apiEndpointRoot = `${environment.apiSecurityHost}/platform/rbac/modules`;
  protected apiEndpointPOSTTemplate = '/{code}';

  protected formTitle: string = 'Platform Module';
  protected formSubtitle: string = 'Add or edit a specific module.';
  protected tableTitle: string = 'Platform Modules';
  protected tableSubtitle: string = 'Groups of functionality used to allow users access to sets of features';

}
